import { Card } from "antd";
import dayjs from "dayjs";
import { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import tw from "tailwind-styled-components";
import { clearDayPartSchedule, deleteSingledayPartSchedule, getSingledayPartSchedule } from "../../redux/rtk/features/dayPartSchedule/dayPartSlice";
import BtnLoader from "../loader/BtnLoader";
import Loader from "../loader/loader";
import PageTitle from "../page-header/PageHeader";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import BtnDeleteSvg from "../UI/Button/btnDeleteSvg";
import DayHoursEdit from "../UI/PopUp/DayHoursEditPopup";

const DetailDayHours = () => {
    const { id } = useParams();
    let navigate = useNavigate();
    const { dayPart, loading } = useSelector(
        (state) => state.dayPart
    );

    //dispatch
    const dispatch = useDispatch();

    //Delete Supplier
    const onDelete = async () => {
        try {
            const resp = await dispatch(deleteSingledayPartSchedule(id));
            if (resp.payload.message === "success") {
                return navigate(-1);
            }
        } catch (error) {
            console.log(error.message);
        }
    };

    useEffect(() => {
        dispatch(getSingledayPartSchedule(id));
        console.log("Fetched dayPart:", dayPart);
        return () => {
            dispatch(clearDayPartSchedule());
        };
    }, []);

    const isLogged = Boolean(localStorage.getItem("isLogged"));

    if (!isLogged) {
        return <Navigate to={"/admin/auth/login"} replace={true} />;
    }

    return (
        <div>
            <PageTitle title=' Back  ' />
            <UserPrivateComponent permission={"readSingle-publicHoliday"}>
                <Card className='mr-top mt-5'>
                    {dayPart ? (
                        <Fragment key={dayPart.id}>
                            <div>
                                <div className='flex justify-between '>
                                    <h3 className={"text-xl"}>
                                        ID : {dayPart.id}
                                    </h3>
                                </div>
                                <div className='flex justify-center mt-5 mb-4 '>
                                    <Card
                                        style={{ width: 500 }}
                                        title='Details of Day Part Schedule'
                                        extra={
                                            <div className='flex justify-end '>
                                                <DayHoursEdit data={dayPart} />
                                                {!loading ? (
                                                    <button className='ml-2' onClick={onDelete}>
                                                        <BtnDeleteSvg size={20} />
                                                    </button>
                                                ) : (
                                                    <BtnLoader />
                                                )}
                                            </div>
                                        }>
                                        <div className='flex justify-center'>
                                            <ul className='list-inside list-none '>
                                                <ListItem>
                                                    Full Day Hours :{" "}
                                                    <TextInside>
                                                        {(dayPart?.fullDayHours)}{" "}
                                                    </TextInside>
                                                </ListItem>
                                                <ListItem>
                                                    Half Day Hours :{" "}
                                                    <TextInside>
                                                        {(dayPart?.halfDayHours)}{" "}
                                                    </TextInside>
                                                </ListItem>

                                                <ListItem>
                                                    Created At :{" "}
                                                    <TextInside>
                                                        {dayjs(dayPart?.createdAt).format(
                                                            "DD/MM/YYYY"
                                                        )}
                                                    </TextInside>
                                                </ListItem>

                                                <ListItem>
                                                    Updated At :{" "}
                                                    <TextInside>
                                                        {dayjs(dayPart?.updatedAt).format(
                                                            "DD/MM/YYYY"
                                                        )}
                                                    </TextInside>
                                                </ListItem>
                                            </ul>
                                        </div>
                                    </Card>
                                </div>
                            </div>
                        </Fragment>
                    ) : (
                        <Loader />
                    )}
                </Card>
            </UserPrivateComponent>
        </div>
    );
};

const ListItem = tw.li`
text-sm
text-gray-600
font-semibold
py-2
px-4
bg-gray-100
mb-1.5
rounded
w-96
flex
justify-start
`;

const TextInside = tw.p`
ml-2
text-sm
text-gray-900
`;

export default DetailDayHours;
